import { render, staticRenderFns } from "./SpamEmailForm.vue?vue&type=template&id=0d3305d0&scoped=true"
import script from "./SpamEmailForm.vue?vue&type=script&lang=js"
export * from "./SpamEmailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3305d0",
  null
  
)

export default component.exports